module.exports = __webpack_public_path__ + "static/media/white_add_prod.855fbbcb.png";